import styled from 'styled-components';
import { breakpoints } from '@theme/breakpoints';
import chevron_down from '@public/Chevron_down.svg';

export const StyledSimpleFAQ = styled.div<{ isOpen: boolean }>`
  background-color: ${({ isOpen }) => (isOpen ? '#FFFFFF' : '#E5E5FF')};
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 255, 0.08);
  transition: all 0.3s ease-in-out;
  flex: 1 1 calc(100% - 50px);
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  text-align: center;
  min-width: 150px;
  height: ${({ isOpen }) => (isOpen ? 'auto' : '53px')};

  @media ${breakpoints.tablet} {
    flex: 1 1 calc(50% - 50px);
  }

  & button {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: none;
    border: none;
    width: 100%;
    text-align: left;
    font-family: Geomanist;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    cursor: pointer;
    padding: 0;
    vertical-align: middle;
    color: #0000FF;
    min-height: 53px;

    &::after {
      content: '';
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%) rotate(${({ isOpen }) => (isOpen ? '180deg' : '0deg')});
      transition: transform 0.3s ease;
      width: 34px;
      height: 34px;
      background-image: url(${chevron_down.src});
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      pointer-events: none;
    }
  }

  .answer {
    vertical-align: middle;
    color: #000000;
    overflow: hidden;
    transition: max-height 0.3s ease;
    text-align: left;

    & p {
      font-family: Roboto;
      font-weight: 400;
      font-size: 16px;
      line-height: 26px;
      color: #000;
      margin-bottom: 20px;
    }
  }
`;

export const StyledSimpleFAQs = styled.section`
  padding-top: 3rem;
  padding-bottom: 5rem;
  max-width: 1200px;
  margin: 0 auto;

  & h2 {
    font-family: Geomanist;
    font-weight: 700;
    font-size: 40px;
    line-height: 42px;
    letter-spacing: 0;
    text-align: center;
    vertical-align: middle;
    background: linear-gradient(90deg, #0402fd, #f4111b);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;
    margin: 2.5rem 0 2rem;
  }

  .wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 20px 50px;

    & ul {
      line-height: 24px;
      list-style-type: disc;
      padding-inline-start: 20px;
    }
  }
`;
